// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"74":"492c0dd9","385":"74c05a66","395":"3b2b65ce","495":"864f4b84","721":"1a66304f","871":"f9ac4326"}[chunkId] + ".css";
};